import { useCallback, useEffect, useState } from 'react'
import { getTaskCounts } from 'actions/collaborativeTasks'

const DEFAULT = { open: 0, completed: 0, withExternalUser: 0 }

/**
 * Returns the counts shown in the Tasks tab header
 * ("3 open · 2 completed · 2 with external user") and the badge.
 */
export const useTaskCounts = (applicationUuid) => {
    const [counts, setCounts] = useState(DEFAULT)
    const [loading, setLoading] = useState(false)

    const fetchData = useCallback(async () => {
        if (!applicationUuid) return
        setLoading(true)
        try {
            const res = await getTaskCounts(applicationUuid)()
            const payload = res?.response || res
            setCounts({
                open: payload?.open || 0,
                completed: payload?.completed || 0,
                withExternalUser: payload?.withExternalUser || 0
            })
        } catch (e) {
            setCounts(DEFAULT)
        } finally {
            setLoading(false)
        }
    }, [applicationUuid])

    useEffect(() => { fetchData() }, [fetchData])

    return { counts, loading, refetch: fetchData }
}
